import {
  Col, Layout, Row
} from 'antd';
import UserInfo from 'components/UserInfo';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Auxiliary from 'util/Auxiliary';
import { switchLanguage, toggleCollapsedSideNav } from '../../appRedux/actions/Setting';
import {
  NAV_STYLE_DRAWER, NAV_STYLE_FIXED, NAV_STYLE_MINI_SIDEBAR, TAB_SIZE
} from '../../constants/ThemeSetting';

const { Header } = Layout;

class Topbar extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const {
      width, navCollapsed, navStyle, userInfo
    } = this.props;
    return (
      <Auxiliary>
        <Header className="qti-layout-header">
          <Row align="middle" justify="space-between" style={{ width: '100%' }} type="flex">
            {navStyle === NAV_STYLE_DRAWER
              || ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) && width < TAB_SIZE)
              ? (
                <Col sm={3} xs={4}>
                  <div className="gx-linebar gx-mr-3">
                    <i
                      className="gx-icon-btn icon icon-menu"
                      onClick={() => {
                        this.props.toggleCollapsedSideNav(!navCollapsed);
                      }}
                    />
                  </div>
                </Col>
              )
              : null}
            <Col lg={14} sm={15} xs={12}>
              {width >= TAB_SIZE
                ? <div style={{ marginBottom: -8 }}><h3>CƠ SỞ DỮ LIỆU CHUYÊN NGÀNH DÂN TỘC</h3></div>
                : null}
            </Col>
            <Col lg={10} sm={6} xs={8}>
              <Row justify="end" type="flex">
                <UserInfo isDesktop={width >= TAB_SIZE} userInfo={userInfo} />
              </Row>
            </Col>
          </Row>
        </Header>
      </Auxiliary>
    );
  }
}

Topbar.propTypes = {
  width: PropTypes.number,
  navCollapsed: PropTypes.bool,
  navStyle: PropTypes.string,
  userInfo: PropTypes.objectOf(PropTypes.any).isRequired,
  toggleCollapsedSideNav: PropTypes.func.isRequired
};

Topbar.defaultProps = {
  width: undefined,
  navCollapsed: false,
  navStyle: ''
};

const mapStateToProps = ({ settings }) => {
  const {
    locale, navStyle, navCollapsed, width
  } = settings;
  return {
    locale, navStyle, navCollapsed, width
  };
};

export default connect(mapStateToProps, { toggleCollapsedSideNav, switchLanguage })(Topbar);
